var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    stroke: "#595959",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 9.5 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.692,
    cy: 3,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.692 3H0m18.692 0h-10"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 15H.308m18.384 0H10M4 3H.308m18.384 0H10"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8c8c7d42.svg";
export { ForwardRef as ReactComponent };